<script lang="ts" setup>

//vue
import { onMounted, reactive, watch } from "vue";
import { useRouter } from "vue-router";

//servicos
import * as service from "@/services/BoletosService";
import { f2dec} from "@/utils/funcoes";

//componentes
import MsgBox from "@/components/MsgBox/Index.vue";
import TextBox from "@/components/TextBox/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import DropdownParamBoleto from "@/components/Dropdowns/DropdownParamBoleto.vue";
import Loading from "@/components/Loading/index.vue";

interface IProps {
    exibir: boolean
}

var props = defineProps<IProps>();
var emit = defineEmits(["importou","erro", "fechou"]);
const router = useRouter();

var controle = reactive({ 
    
    janRetorno: false,
    param: {
        paramBoletoId: 1,
        arquivo: null as File | null,
    } as service.ImportarRetornoDTO & { arquivo: File | null },

    loading: false,
    status: "",
    erro: ""
});

onMounted(() => {
    console.log("onMounted");

})

watch(() => props.exibir, async (novoValor) => {

    controle.janRetorno = novoValor;

    if (controle.janRetorno == true)
    {
        setTimeout(() => {
            var jan = document.getElementById("janRetorno");
            var el = jan?.querySelector("#inputFocus") as HTMLInputElement;
            if (el != undefined)
                el.focus();
        }, 700);
    }

})

function onFileChange(event: Event) {
    const target = event.target as HTMLInputElement;

    console.log("target.files", target.files);

    if (target.files && target.files.length > 0) {
        controle.param.arquivo = target.files[0];
    } else {
        controle.param.arquivo = null;
    }
}

async function importar(){

    controle.erro = "";
    controle.status = "";
    controle.loading = true;

    controle.status = `Importando retorno ...`;

    await service.importarRetorno(controle.param)
    .then(r=> {
        controle.status =  `Importado com sucesso`;
        emit("importou");
                
        setTimeout(() => {
            controle.loading = false;
            fechar();
            // Redirecionar para a página de itens do retorno
            router.push({ name: "boletosRetornosItens", params: { id: r.retornoId } });
        }, 4000);

        controle.janRetorno = false;
    })  
    .catch((erro) => {
        controle.erro = erro;
        controle.status = "Erro: " + erro ;
        controle.loading = false;
        emit("erro", erro);
    });
}


function fechar() {
    controle.janRetorno = false;
    emit("fechou");
}

</script>



<template>

    <Loading :isLoading="controle.loading" :mensagem="controle.status" />

    <MsgBox :id="'janRetorno'" :titulo="'Importar retorno'"  :exibir="controle.janRetorno"  @onFechou="controle.janRetorno = false" >
        <TrataTecla>

            <div class="row mb-2" >
                <div class="col-md-2">
                      <label>Arquivo</label>
                </div>
                <div class="col-md-10">
                    <input type="file" class="form-control form-control-sm" @change="onFileChange" ref="arquivo" >
                </div>
            </div>

            <div class="row mb-2">
                <div class="col-md-2">
                    Convênio
                </div>
                <div class="col-md-10">
                    <DropdownParamBoleto v-model="controle.param.paramBoletoId" id="inputFocus  "/>
                </div>
            </div>
            
            <div class="row mb-2" >
                <div class="col-md-2">
                    <label>Usuário</label>
                </div>
                <div class="col-md-4">
                     <input type="text" class="form-control form-control-sm" v-model="controle.param.nomeUsuario" id="nomeUsuario" ref="nomeUsuario">
                </div>
            </div>

            <div class="row mb-2" >
                <div class="col-md-2">
                      <label>Senha</label>
                </div>
                <div class="col-md-4">
                    <input type="password" class="form-control form-control-sm" v-model="controle.param.senha" ref="senha" >
                </div>
            </div>

            <div class="row" v-if="controle.erro != ''">
                <div class="col-md-2"></div>
                <div class="col-md-10 fw-bold text-danger">
                    {{controle.erro}}
                </div>
            </div>

            <div class="row" v-if="controle.status != '' && controle.erro == ''">
                <div class="col-md-2"></div>
                <div class="col-md-10 fw-bold ">
                    <i class="fa fa-cog fa-spin"></i> {{controle.status}}
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <hr>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <button type="button" class="btn btn-primary btn-sm" @click="importar()" :disabled="controle.loading">Importar</button>
                </div>
                <div class="col-md-6">
                    <a class="btn btn-secondary btn-sm float-end" @click="fechar()" :disabled="controle.loading">Fechar</a>
                </div>
            </div>
        </TrataTecla>
    </MsgBox>
</template>